<script>
  import IntersectionObserver from '../../util/IntersectionObserver.svelte'
  import AnimatedValuePrimitive from '../../primitives/AnimatedValuePrimitive.svelte'

  /** @type {number} */
  export let value = undefined

  export let store = undefined

  $: storeValue = store ? $store : undefined

  /** 
   * Setting this option to true will ignore the numberOfDecimals use the money formatter ($123,456.78)
   * For a 'decorative' money effect (e.g. for $132M) set the decimal value to what makes sense,
   * and set the suffix and prefix.
   * @type {boolean} 
  */
  export let isMoney = false

  /** @type {string} */
  export let prefix = ''

  /** @type {string} */
  export let suffix = ''

  /** @type {number} */
  export let numberOfDecimals = 0

  /** @type {number} */
  export let animationDuration = 2000

  /** @type {number} */
  export let animationDelay = 150

  let className
  export { className as class }

  export let tag = 'span'
</script>

<IntersectionObserver class="" let:intersecting once>
  { #if intersecting }
      <AnimatedValuePrimitive class={ className } { prefix } value={ store ? storeValue : value } { suffix } { isMoney } { numberOfDecimals } { animationDuration } { animationDelay } { tag } />
    { :else }
      <svelte:element this={ tag } class="animated-value{ className ? ' ' + className : '' }">
        { prefix }0{ suffix }
      </svelte:element>
  { /if }
</IntersectionObserver>